import { useMutation, useQuery } from 'react-query';
import { useAuthorDao } from 'shared/dao/authorDao';
import {
  IAuthorCreatePayload,
  IAuthorExportPayload,
  IAuthorRequestPayload,
  IAuthorResponsePayload,
  IAuthorUpdatePayload,
} from 'shared/interfaces/IAuthor';

const {
  getAuthors: getAuthorsDao,
  getSingleAuthor: getSingleAuthorDao,
  exportAuthors: exportAuthorsDao,
  createAuthor: createAuthorDao,
  deleteAuthor: deleteAuthorDao,
  updateAuthor: updateAuthorDao,
} = useAuthorDao();

export const useAuthorService = () => {
  const getAuthors = (payload?: IAuthorRequestPayload) => {
    return useQuery<IAuthorResponsePayload, Error>(['authors', payload], () => getAuthorsDao(payload));
  };

  const getSingleAuthor = (id?: string) => {
    return useQuery<IAuthorResponsePayload, Error>(['authors', id], () => getSingleAuthorDao(id), {
      enabled: !!id,
    });
  };

  const exportAuthors = () => {
    const exportMutation = useMutation((payload?: IAuthorExportPayload) => exportAuthorsDao(payload));

    return {
      exportMutation,
    };
  };

  const createAuthor = () => {
    const createMutation = useMutation((payload?: { data?: IAuthorCreatePayload; avatar?: File }) =>
      createAuthorDao(payload),
    );

    return {
      createMutation,
    };
  };

  const updateAuthor = () => {
    const updateMutation = useMutation((payload: { data?: IAuthorUpdatePayload; avatar?: File }) =>
      updateAuthorDao(payload),
    );

    return {
      updateMutation,
    };
  };

  const deleteAuthor = () => {
    const deleteMutation = useMutation((id: string) => deleteAuthorDao(id));

    return {
      deleteMutation,
    };
  };

  return {
    getAuthors,
    getSingleAuthor,
    createAuthor,
    updateAuthor,
    deleteAuthor,
    exportAuthors,
  };
  //
};
